import React, { Component } from "react";
import { Collapse, Nav, NavbarToggler, NavItem } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { createFragmentContainer, graphql } from "react-relay";
import auth from "../../helpers/auth";
import "./../../styles/vibrate.scss";
import { init, cleanup, show } from "./../../helpers/script";
import Raptor from "../Common/Raptor";
import { IS_STAGING } from "../../constants";

const Logo = styled.div`
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
`;

const NavText = styled.p`
  padding: 1.4rem 1.25rem 0.5rem 1.5rem;
  font-size: 0.85rem;
  position: relative;
  &:after {
    display: block;
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    height: 70%;
    width: 1px;
    background-color: #fff;
  }

  @media (max-width: 991px) {
    display: none;
  }
`;

const LogOut = styled.a`
  cursor: pointer;
`;

const ManagerIcon = styled.i`
  margin-right: 5px;
`;

class HeaderHorizontal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleDocumentClick, false);
    window.addEventListener("keyup", this.ee);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocumentClick, false);
    window.removeEventListener("keyup", this.ee);
  }

  state = {
    isOpen: false,
    loggedOut: false,
    rap: false,
  };

  ee = ({ keyCode, altKey, ctrlKey }) => {
    const html = document.querySelector("html");
    if (keyCode === 8 && altKey && ctrlKey) {
      const body = document.querySelector("body");
      const oldCanvas = document.querySelector(".canvas");
      if (oldCanvas) {
        cleanup(oldCanvas);
        body.classList.remove("ee");
      } else {
        const canvas = document.createElement("canvas");
        canvas.classList.add("canvas");
        body.appendChild(canvas);
        body.classList.add("ee");
        init();
      }
    }
    if ((keyCode === 187 || keyCode === 189) && altKey && ctrlKey) {
      if (keyCode === 187) show(false);
      if (keyCode === 189) show(true);
    }
    if (altKey && ctrlKey && keyCode === 48) {
      html.style.direction === "rtl"
        ? (html.style.direction = "ltr")
        : (html.style.direction = "rtl");
    }
    if (altKey && ctrlKey && keyCode === 57)
      html.classList.toggle("upsideDown");
    if (altKey && ctrlKey && keyCode === 56)
      this.setState({ rap: Math.random() });
    if (altKey && ctrlKey && keyCode === 55)
      this.setState({ dd: !this.state.dd });
  };

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  logOut = () => {
    auth.logout(() => {
      this.props.history.push("/login");
    });
  };

  handleDocumentClick = (e) => {
    const container = this.refs.node;
    if (
      e.target !== container &&
      !container.contains(e.target) &&
      this.state.isOpen
    ) {
      this.setState({
        isOpen: false,
      });
    }
  };

  render() {
    const location = this.props.location.pathname;
    const isManagement =
      this.props.location.pathname.indexOf("management") !== -1;
    return (
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <Raptor wakeUp={this.state.rap} />
        <nav
          className="navbar topnavbar navbar-expand-lg navbar-light bg-inverse-light"
          ref={"node"}
        >
          {/* START navbar header */}
          <div className="navbar-header">
            <Link className="navbar-brand" to="/dashboard">
              <Logo className="brand-logo">
                MenDayz
                <br />
              </Logo>
            </Link>
            <NavbarToggler onClick={this.toggle} />
          </div>
          <Collapse isOpen={this.state.isOpen} navbar>
            {this.state.dd && (
              <marquee
                style={{
                  color: "pink",
                  position: "fixed",
                  top: "45%",
                  fontSize: "10rem",
                }}
              >
                (╯ ͠° ͟ʖ ͡°)╯┻━┻
              </marquee>
            )}
            {IS_STAGING === "true" && (
              <Nav>
                <NavItem>
                  <h2 style={{ marginTop: "8px", color: "pink" }}>
                    S T A G I N G
                  </h2>
                </NavItem>
              </Nav>
            )}
            {this.props.user && this.props.user.isStaff && (
              <Nav navbar className="flex-row justify-content-start">
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("management") !== -1 && "active"
                    }`}
                    to="/management/dashboard"
                  >
                    <ManagerIcon>
                      <i className="fa fa-users" />
                    </ManagerIcon>
                    Manager
                  </Link>
                </NavItem>
              </Nav>
            )}
            {!isManagement ? (
              <Nav
                navbar
                className="mr-auto ml-auto flex-column flex-lg-row align-items-center"
              >
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("reports") !== -1 && "active"
                    }`}
                    to="reports"
                  >
                    Reports
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("absences") !== -1 && "active"
                    }`}
                    to="absences"
                  >
                    Absences & Vacations
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("account") !== -1 && "active"
                    }`}
                    to="account"
                  >
                    Account
                  </Link>
                </NavItem>
                {/*<NavItem>*/}
                {/*    <Link*/}
                {/*        className={`nav-link ${location.indexOf('basics') !== -1 && "active"}`}*/}
                {/*        to="basics">Basics</Link>*/}
                {/*</NavItem>*/}
              </Nav>
            ) : (
              <Nav
                navbar
                className="mr-auto ml-auto flex-column flex-lg-row align-items-center"
              >
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("management/projects") !== -1 && "active"
                    }`}
                    to="/management/projects/list"
                  >
                    Projects
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("management/staff") !== -1 && "active"
                    }`}
                    to="/management/staff/list"
                  >
                    Staff
                  </Link>
                </NavItem>
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("management/absences") !== -1 && "active"
                    }`}
                    to="/management/absences/list"
                  >
                    Absences & Vacations
                  </Link>
                </NavItem>
                {/*<NavItem>*/}
                {/*    <Link*/}
                {/*        className={`nav-link ${location.indexOf('management/basics') !== -1 && "active"}`}*/}
                {/*        to="/management/basics">Basics</Link>*/}
                {/*</NavItem>*/}
                <NavItem>
                  <Link
                    className={`nav-link ${
                      location.indexOf("management/meetings") !== -1 && "active"
                    }`}
                    to="/management/meetings"
                  >
                    Meetings
                  </Link>
                </NavItem>
                {/*<NavItem>*/}
                {/*<Link className="nav-link" to="/management/meetings">Meetings</Link>*/}
                {/*</NavItem>*/}
              </Nav>
            )}
            <Nav navbar className="flex-row justify-content-end">
              <NavItem>
                <NavText>{this.props.user.displayName}</NavText>
              </NavItem>
              <NavItem>
                <LogOut className="nav-link" onClick={this.logOut}>
                  log out
                </LogOut>
              </NavItem>
            </Nav>
          </Collapse>
        </nav>
      </header>
    );
  }
}

// export default HeaderHorizontal;
const HeaderHorizontalFragment = createFragmentContainer(HeaderHorizontal, {
  user: graphql`
    fragment HeaderHorizontal_user on UserType {
      displayName
      isStaff
    }
  `,
});

export default withRouter(HeaderHorizontalFragment);



// WEBPACK FOOTER //
// ./src/components/Layout/HeaderHorizontal.js